export const FB_API_KEY = process.env.REACT_APP_FB_API_KEY;
